import React from "react";
import { compose } from "react-apollo";
import { withStore } from "../../store";
import { SVGImage, SVG } from "../../assets/images";
import classnames from "classnames";
import { getPageType } from "../../utils";
import "./PerformanceActions.scss";

let shareMenuCounter = 0;

class PerformanceActions extends React.Component<any, any> {
  private shareWrapperRef = React.createRef<HTMLDivElement>();
  private shareTriggerRef = React.createRef<HTMLButtonElement>();
  private shareMenuId = `performance-share-menu-${++shareMenuCounter}`;

  state = { shareOpen: false };

  componentDidMount() {
    document.addEventListener("keydown", this.onDocumentKeyDown);
    document.addEventListener("mousedown", this.onDocumentMouseDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.onDocumentKeyDown);
    document.removeEventListener("mousedown", this.onDocumentMouseDown);
  }

  toggleShare = () => {
    this.setState((s: any) => ({ shareOpen: !s.shareOpen }));
  };

  closeShare = (returnFocus = false) => {
    if (!this.state.shareOpen) return;
    this.setState({ shareOpen: false }, () => {
      if (returnFocus && this.shareTriggerRef.current) {
        this.shareTriggerRef.current.focus();
      }
    });
  };

  // Escape while the menu is open → close and return focus to the trigger.
  onDocumentKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Escape" && this.state.shareOpen) {
      this.closeShare(true);
    }
  };

  // Click outside the wrapper → close (no focus return — preserves the click
  // target's natural focus behavior).
  onDocumentMouseDown = (e: MouseEvent) => {
    if (!this.state.shareOpen) return;
    const wrapper = this.shareWrapperRef.current;
    if (wrapper && !wrapper.contains(e.target as Node)) {
      this.closeShare(false);
    }
  };

  render() {
    const { inFavorites, showFavoriteAction, onToggleFavorite, store: { user } } = this.props;
    const { shareOpen } = this.state;
    const url = window.location.href;
    const pageType = getPageType();
    const isBroadcastPage = (pageType === "broadcast");
    const isStudent = user && user.data && user.institutionName;

    return (
      <div className="performance-actions">
        { !isBroadcastPage && user && !isStudent && showFavoriteAction &&
          /* MET2-2863: div onClick → button with aria-pressed for toggle semantics */
          <button
            type="button"
            className={classnames("performance-favorite", inFavorites ? "in-favorites" : "")}
            onClick={onToggleFavorite}
            aria-pressed={!!inFavorites}
            aria-label={inFavorites ? "Remove from favorites" : "Add to favorites"}
          >
            <span aria-hidden="true"><SVG.FavoriteIcon /></span><span aria-hidden="true">Favorite</span>
          </button>
        }
        {/* MET2-2881: disclosure pattern — the trigger is a button with
            aria-expanded/controls/haspopup; the share links are revealed by
            CSS when .is-open is present (matching the existing :hover
            reveal). Escape + outside click close the menu. */}
        <div
          className={classnames("performance-social-share", shareOpen && "is-open")}
          ref={this.shareWrapperRef}
        >
          <ul className="performance-social-share-buttons" id={this.shareMenuId}>
            <li>
              <a
                href={`http://www.facebook.com/sharer.php?u=${url}`}
                target="_blank"
                rel="noreferrer"
                className="fb"
                aria-label="Share on Facebook"
                tabIndex={shareOpen ? 0 : -1}
              >
                <SVG.Facebook aria-hidden="true" />
              </a>
            </li>
            <li>
              <a
                href={`http://twitter.com/home?status=${url}`}
                target="_blank"
                rel="noreferrer"
                className="twitter"
                aria-label="Share on Twitter"
                tabIndex={shareOpen ? 0 : -1}
              >
                <SVG.Twitter aria-hidden="true" />
              </a>
            </li>
          </ul>
          <button
            type="button"
            className="performance-share-trigger"
            onClick={this.toggleShare}
            aria-expanded={shareOpen}
            aria-controls={this.shareMenuId}
            aria-haspopup="true"
            ref={this.shareTriggerRef}
          >
            <img src={SVGImage.Share} alt="" aria-hidden="true" />Share
          </button>
        </div>
      </div>
    )
  }
}

export default compose(withStore)(PerformanceActions);
